import PropTypes from "prop-types";
import React, { useState, useContext, useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useSelector } from "react-redux";
import CoinContext from "contexts/CoinContext";
import { useDispatch } from "react-redux";
import { map_coins, map_balance_to_coin } from "store/constant";
import { Tab, Tabs } from "@material-ui/core";
import SelectedExchange from "ui-component/SelectedExchange";
import colors from 'assets/scss/_themes-vars.module.scss';


import {
  placeOrderTicket,
  orderTicketTimeout,
  OrderTicketTypes,
} from "store/actions";

import {
  Divider,
  InputAdornment,
  OutlinedInput,
  InputLabel,
  IconButton,
  Chip,
  Fab,
  Box,
} from "@material-ui/core";
import MUIFormControl from "@material-ui/core/FormControl";
import Transitions from "ui-component/extended/Transitions";

// material-ui
import { makeStyles, useTheme } from "@material-ui/styles";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Button,
  TextField,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import SubCard from "ui-component/cards/SubCard";
import useSocket from "hooks/useSocket";
import useOrderTicket from "hooks/useOrderTicket";
import { addOrder } from "emitters";
import { IconSettings } from "@tabler/icons";

import { IconLoader } from "@tabler/icons";
import AnimateButton from "ui-component/extended/AnimateButton";

// style constant
const useStyles = makeStyles((theme) => ({
  revenueCard: {
    position: "relative",
    color: "#fff",
    background: "#00070f",
  },
  revenueIcon: {
    position: "absolute",
    right: "13px",
    top: "14px",
    color: "#fff",
    background: "#00070f",
    "&> svg": {
      width: "100px",
      height: "100px",
      opacity: "0.5",
    },
    [theme.breakpoints.down("xs")]: {
      top: "13px",
      "&> svg": {
        width: "80px",
        height: "80px",
      },
    },
  },
}));

// =============================|| REVENUE CARD ||============================= //

const TrendingBuySummary = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const theme = useTheme();
  const green = (theme.palette.mode === 'dark') ? colors.successLightTakyon : colors.successDarkTakyon;
  const red = (theme.palette.mode === 'dark') ? colors.errorLightTakyon : colors.errorDarkTakyon;

  const matchDownXs = useMediaQuery(theme.breakpoints.down("xs"));
  let textc = "lightyellow";
  if (theme.palette.background.paper === "#ffffff") {
    textc = "darkred";
  }

  
  const [selectedExchange, exchanges] = useSelector((state) => [
    state.exchange.selectedExchange,
    state.exchange.exchanges,
  ]);


  const { coin } = useContext(CoinContext);

    const trending_buy = useSelector((state) => {
        return ((state.coins.kraken_asset_pairs_loaded && state.coins.kraken_asset_pairs.get(coin) && state.coins.kraken_asset_pairs.get(coin).trending_buy)?state.coins.kraken_asset_pairs.get(coin).trending_buy : undefined);
    });

    const rung = 'green';
    const lrung = 'green';
    const trending_sell = useSelector((state) => {
        return ((state.coins.kraken_asset_pairs_loaded && state.coins.kraken_asset_pairs.get(coin) && state.coins.kraken_asset_pairs.get(coin).trending_sell)?state.coins.kraken_asset_pairs.get(coin).trending_sell : undefined);
    });
    const position = useSelector((state) => {
        return ((state.coins.kraken_asset_pairs_loaded && state.coins.kraken_asset_pairs.get(coin) && state.coins.kraken_asset_pairs.get(coin).position)?state.coins.kraken_asset_pairs.get(coin).position : undefined);
    });

    const swl_single = useSelector((state) => {
        return ((state.coins.kraken_asset_pairs_loaded && state.coins.kraken_asset_pairs.get(coin) && state.coins.kraken_asset_pairs.get(coin).swl_single)?state.coins.kraken_asset_pairs.get(coin).swl_single : undefined);
    });

  const spot = map_balance_to_coin.get(coin);
  const coin_style = map_coins.get(coin);

  return (
    <SubCard>
                <Grid container padding={1} alignItems="center" spacing={1}>

                    <Grid item xs={12} alignItems="center" textAlign="center">
                        <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: 'cornsilk' }}>
                            {'Breakout Summary'}
                        </font>
                    </Grid>

                    <Grid item xs={12} lg={12} alignItems="center"  textAlign="center">
                        <a class={coin_style}>{coin}</a>
                    </Grid>

                    <Grid item xs={12} lg={12} />
                    <Grid item xs={12} lg={12} />

                    <Grid item xs={12} lg={6}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: '#fff' }}>
                                        {'Breakout'}
                                    </font>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: rung }}>
                                        {swl_single && swl_single.percent.toFixed(2)}{'%'}
                                    </font>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: '#fff' }}>
                                        {'LTP'}
                                    </font>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: lrung }}>
                                        {swl_single && swl_single.end_ref}
                                    </font>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: '#fff' }}>
                                        {trending_buy && 'Last Buy'}
                                        {trending_sell && 'Last Buy'}
                                    </font>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: rung }}>
                                        
                                        {trending_buy && (trending_buy.qty * trending_buy.position).toFixed(2)}
                                        {trending_sell && (trending_sell.qty * trending_sell.position).toFixed(2)}
                                    </font>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: '#fff' }}>
                                        {'Invested'}
                                    </font>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: rung }}>
                                        {position && position.invested}
                                    </font>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: '#fff' }}>
                                        {'Profit %'}
                                    </font>
                    </Grid>
                    <Grid item xs={12} lg={2}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: rung }}>
                                        {position && position.percent}
                                    </font>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: '#fff' }}>
                                        {'Avg.Px.'}
                                    </font>
                    </Grid>
                    <Grid item xs={12} lg={6}>
                                    <font style={{ textAlign: 'right', fontSize: '1.3rem', fontWeight: 'normal', bgcolor: '#00070f', color: 'orange' }}>
                                        {position && position.remaining_avg_price}
                                    </font>
                    </Grid>
                </Grid>
    </SubCard>
  );
};

TrendingBuySummary.propTypes = {};

export default React.memo(TrendingBuySummary);
